import { useEffect, useState } from 'react';
import api from '../services/api';
import { Card } from '../components/ui';

export default function Dashboard() {
  const userStr = localStorage.getItem('user');
  let user = null;
  try {
    user = userStr ? JSON.parse(userStr) : null;
  } catch {
    user = null;
  }

  const [stats, setStats] = useState({ total: 0, active: 0, suspended: 0, expired: 0 });

  useEffect(() => {
    api.get('/admin/licenses')
      .then(res => {
        const licenses = res.data;
        setStats({
          total: licenses.length,
          active: licenses.filter((l: any) => l.status === 'active').length,
          suspended: licenses.filter((l: any) => l.status === 'suspended').length,
          expired: licenses.filter((l: any) => l.status === 'expired').length,
        });
      })
      .catch(() => {});
  }, []);

  if (!user || user.role !== 'admin') {
    return (
      <div className="flex items-center justify-center h-full p-8">
        <p className="text-gray-500 text-lg">Dashboard cliente (próximamente)</p>
      </div>
    );
  }

  return (
    <div className="p-8">
      <h1 className="font-display text-2xl font-bold text-gray-100 mb-8">Dashboard</h1>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
        <Card padding="lg" className="flex items-center gap-4">
          <div className="w-12 h-12 rounded-xl bg-rs-accent/20 flex items-center justify-center">
            <svg className="w-6 h-6 text-rs-accent" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
          </div>
          <div>
            <p className="text-2xl font-display font-bold text-gray-100">{stats.total}</p>
            <p className="text-sm text-gray-500">Total licencias</p>
          </div>
        </Card>
        <Card padding="lg" className="flex items-center gap-4">
          <div className="w-12 h-12 rounded-xl bg-emerald-500/20 flex items-center justify-center">
            <svg className="w-6 h-6 text-emerald-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
            </svg>
          </div>
          <div>
            <p className="text-2xl font-display font-bold text-gray-100">{stats.active}</p>
            <p className="text-sm text-gray-500">Activas</p>
          </div>
        </Card>
        <Card padding="lg" className="flex items-center gap-4">
          <div className="w-12 h-12 rounded-xl bg-amber-500/20 flex items-center justify-center">
            <svg className="w-6 h-6 text-amber-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
            </svg>
          </div>
          <div>
            <p className="text-2xl font-display font-bold text-gray-100">{stats.suspended}</p>
            <p className="text-sm text-gray-500">Suspendidas</p>
          </div>
        </Card>
        <Card padding="lg" className="flex items-center gap-4">
          <div className="w-12 h-12 rounded-xl bg-red-500/20 flex items-center justify-center">
            <svg className="w-6 h-6 text-red-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            </svg>
          </div>
          <div>
            <p className="text-2xl font-display font-bold text-gray-100">{stats.expired}</p>
            <p className="text-sm text-gray-500">Expiradas</p>
          </div>
        </Card>
      </div>
    </div>
  );
}
